import styled from 'styled-components';
import { getTextColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import { Pin } from '@magalu/stereo-ui-icons';
import Flex from '../../atoms/Flex';
export const TextContainer = styled(Flex)`
  align-items: center;
  max-height: 44px;
  cursor: pointer;
`;
export const Text = styled(Flex).attrs(() => ({
  alignItems: ['center', 'flex-start', 'flex-start'],
  color: 'text.lightest',
  flexDirection: ['row', 'column', 'column'],
  fontSize: 0,
  fontWeight: 'normal'
}))``;
export const Span = styled(Text).attrs(() => ({
  ml: [1, 0, 0],
  fontWeight: 'bold'
}))``;
export const IconContainer = styled(Flex)`
  ${getMediaQuery('small')} {
    max-height: 44px;
    max-width: 44px;
    width: 100%;
  }
`;
export const PinIcon = styled(Pin).attrs(props => ({
  color: getTextColor('lightest')(props)
}))``;